/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResultStringDto } from '../../models/result-string-dto';

export interface UpdateCustomerAvatar$Params {
  customerId: number;
      body: {
}
}

export function updateCustomerAvatar(http: HttpClient, rootUrl: string, params: UpdateCustomerAvatar$Params, context?: HttpContext): Observable<StrictHttpResponse<ResultStringDto>> {
  const rb = new RequestBuilder(rootUrl, updateCustomerAvatar.PATH, 'post');
  if (params) {
    rb.path('customerId', params.customerId, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResultStringDto>;
    })
  );
}

updateCustomerAvatar.PATH = '/api/avatar/customer/{customerId}';
